var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.273501 19.0873C0.109159 19.8424 0.688977 20.1621 1.22698 19.9209L19.4101 10.5973H19.412C19.6288 10.475 19.7548 10.2545 19.7548 10.0002C19.7548 9.74577 19.6288 9.52518 19.412 9.4029H19.4101L1.22698 0.0790995C0.688977 -0.16215 0.109159 0.157638 0.273501 0.91287C0.284622 0.964026 1.35959 5.75238 1.94406 8.3566L11.436 10.0002L1.94406 11.6435C1.35959 14.2476 0.284572 19.0361 0.273501 19.0873Z",
    fill: "#0c3255"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.3f2ec4c8acbc5cb27f96350efa3208ee.svg";
export { ForwardRef as ReactComponent };